import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiTv } = FiIcons;

const Header = ({ currentTime }) => {
  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className="bg-black/90 backdrop-blur-lg border-b border-blue-500/30 sticky top-0 z-50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo and Station Name */}
          <Link to="/" className="flex items-center space-x-3 group">
            <div className="w-10 h-10 lg:w-12 lg:h-12 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
              <SafeIcon icon={FiTv} className="text-white text-xl lg:text-2xl" />
            </div>
            <div className="hidden sm:block">
              <h1 className="text-lg lg:text-xl font-bold text-white">
                Ligon Road
              </h1>
              <p className="text-xs lg:text-sm text-blue-400 -mt-1">Innovations LLC TV</p>
            </div>
          </Link>

          {/* Live Indicator */}
          <div className="flex items-center space-x-2">
            <div className="flex items-center space-x-2 bg-red-600 px-3 py-1 rounded-full">
              <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
              <span className="text-white text-sm font-medium">LIVE</span>
            </div>
            <div className="text-blue-400 text-sm hidden sm:block">
              {currentTime.toLocaleTimeString()}
            </div>
          </div>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;